import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { HumanTimeAgo } from '@scripts/utilities/time.js';
import TimeFormat from '@scripts/utilities/time-format.js';

import Clock from '../../Icons/clock.jsx';

import { getCurrentTime } from '../../Store/current-time.js';


// a global setting to allow us to auto-generate unique ID's for each popover.
let id = 0;


class UpdatedPopover extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: id++
    };
  }

  render() {
    if (this.props.timestamp) {
      return (
        <OverlayTrigger overlay={this.overlay()}>
          <button className="cs-updated-popover">
            <Clock />
          </button>
        </OverlayTrigger>
      );
    } else {
      return null;
    }
  }

  overlay() {
    return (
      <Tooltip id={"updated-popover-" + this.state.id}>
        Price Data Last Updated<br />
        {HumanTimeAgo(this.props.currentTime - this.props.timestamp)} <br />
        ({TimeFormat(this.props.timestamp)})
      </Tooltip>
    );
  }
}


UpdatedPopover.propTypes = {
  timestamp: PropTypes.number
};


var mapStateToProps = function(state) {
  return {
    currentTime: getCurrentTime(state)
  };
};


export default connect(mapStateToProps)(UpdatedPopover);

